import { FEATURE, ROUTES } from "./Common";
import { Home, Receipt, Image, QuestionCircle, IdCard, User } from "@livingdesign/icons";
import analyticsIcon from "../assets/icons/analytics.svg";

export const PAGES = {
  HOME: {
    label: "Home",
    icon: <Home size="small" />,
    route: ROUTES.FOLDERS,
  },
  TEAMS: {
    label: "Manage teams",
    icon: <User size="small" />,
    isExternal: true,
  },
  ANALYTICS: {
    label: "Analytics",
    route: ROUTES.ANALYTICS,
    icon: <img src={analyticsIcon} alt="Analytics" />,
    toggle: FEATURE.ANALYTICS_SECTION,
  },
  REPORT: {
    label: "Report",
    route: ROUTES.REPORT,
    icon: <Receipt size="small" />,
    toggle: FEATURE.REPORT_SECTION,
  },
  RECIPIENTS: {
    label: "Recipients",
    route: ROUTES.RECIPIENTS,
    icon: <IdCard size="small" />,
    toggle: FEATURE.SAVED_RECIPIENTS,
  },
  TEMPLATE: {
    label: "Template",
    icon: <Receipt size="small" />,
    route: ROUTES.TEMPLATES,
  },
  MEDIA_LIBRARY: {
    label: "Media",
    icon: <Image size="small" />,
    route: ROUTES.MEDIA_LIBRARY,
    toggle: FEATURE.MEDIA_LIBRARY,
  },
  HELP: {
    label: "Help",
    icon: <QuestionCircle size="small" />,
    isExternal: true,
    toggle: FEATURE.HELP_SECTION,
  },
};

export const ACTIONS = {
  RECIPIENT_PAGE_SAVED_FILTERS_VIEW: "RECIPIENT_PAGE_SAVED_FILTERS_VIEW",
  RECIPIENT_PAGE_FILTER_VIEW: "RECIPIENT_PAGE_FILTER_VIEW",
  RECIPIENT_PAGE_FILTER_CREATE: "RECIPIENT_PAGE_FILTER_CREATE",
  RECIPIENT_PAGE_FILTER_EDIT: "RECIPIENT_PAGE_FILTER_EDIT",
  CAMPAIGN_PAGE: "CAMPAIGN_PAGE",
}
